import { registerDefaults, registerRoutes } from "../components/NamedRoutes";
import { localeRouteParam, Locales } from "./locale";

registerRoutes({
  "home-default": `/${Locales.default}`,
  home: `/${localeRouteParam}?`,
  "guide-lines": `/${localeRouteParam}/guide-lines`,
  systems: `/${localeRouteParam}/system`,
  system: `/${localeRouteParam}/system/:id`,
  "system:events": `/${localeRouteParam}/system/:id/events/:page?`,
  "system:events-page2": `/${localeRouteParam}/system/:id/events-page2`,
  "system:elements": `/${localeRouteParam}/system/:id/elements/:page?`,
  "system:element-comment": `/${localeRouteParam}/system/:id/element-comment/:numberGroup?/:group?/:element?`,
  "system:settings": `/${localeRouteParam}/system/:id/settings`,
  "system:shares": `/${localeRouteParam}/system/:id/share`,
  "system:share-settings": `/${localeRouteParam}/system/:id/share/:userId`, //`:systemId/share/`:userId`,
  "system:phonenumber": `/${localeRouteParam}/system/:id/phonenumber`,

  "system:documentationhistory": `/${localeRouteParam}/system/:id/documentation-history`,
  "system:displaydevice": `/${localeRouteParam}/system/:id/display-device`,
  "system:powerunitsDocumentation": `/${localeRouteParam}/system/:id/power-units-documentation`,
  "system:otheralarmdevices": `/${localeRouteParam}/system/:id/other-alarm-devices`,
  "system:otherdevices": `/${localeRouteParam}/system/:id/other-devices`,
  "system:inputssystemDocumentation": `/${localeRouteParam}/system/:id/inputs-system-documentation`,
  "system:submissiondocuments": `/${localeRouteParam}/system/:id/submission-documents`,
  "system:typedefinition-submission-documents": `/${localeRouteParam}/system/:id/type-definition-submission-documents`,
  "system:documentation": `/${localeRouteParam}/system/:id/documentation`,
  "system:sent-text-messages-log": `/${localeRouteParam}/system/:id/sent-text-messages-log`,
  "system:elementslist": `/${localeRouteParam}/system/:id/elements-list`,

  "system:plan": `/${localeRouteParam}/system/:id/plan/:planId?`,
  "system:maintenancereport": `/${localeRouteParam}/system/:id/maintenancereport`,
  "system:eventmemory": `/${localeRouteParam}/system/:id/eventmemory`,
  "system:analoguevalues": `/${localeRouteParam}/system/:id/analoguevalues/:numberGroup?/:group?/:element?`,
  "system:queries": `/${localeRouteParam}/system/:id/queries`,
  "system:addsystem": `/${localeRouteParam}/system/:id/new-system`,

  customers: `/${localeRouteParam}/customer`,
  "customer:customers": `/${localeRouteParam}/customer/:id/customers`,
  customer: `/${localeRouteParam}/customer/:id`,
  "customer:systems": `/${localeRouteParam}/customer/:id/systems`,
  "customer:users": `/${localeRouteParam}/customer/:id/users`,
  "customer:events": `/${localeRouteParam}/customer/:id/events`,
  "customer:addcustomer": `/${localeRouteParam}/customer/:id/new-customer`,
  "customer:adduser": `/${localeRouteParam}/customer/:id/new-user`,
  "customer:settings": `/${localeRouteParam}/customer/:id/settings`,

  users: `/${localeRouteParam}/user`,
  user: `/${localeRouteParam}/user/:id`,
  "user:sent-notifications-log": `/${localeRouteParam}/user/:id/sent-notifications-log`,

  "forgot-password": `/${localeRouteParam}/forgot-password`,
  "reset-password": `/${localeRouteParam}/reset-password/:token`,
  // "login-redirect": `/${localeRouteParam}/:rest(?!reset-password|forgot-passwort)`,
  "auth-component": `/${localeRouteParam}?/:component?/:rest(.*)?`,
  login: `/${localeRouteParam}?`,

  priceLists: `/${localeRouteParam}/price-lists`,
  priceList: `/${localeRouteParam}/price-list/:id`,

  debug: `/${localeRouteParam}/debug`,
});

registerDefaults({
  locale: Locales.default,
});
